import React from "react";

import Footer from "../Footer";
import TopBar from "./TopBar";

// Dark theme, top bar and footer shared by every public page. A page can
// pass a `background` (the home page's video) to sit behind the top bar
// and its content.
const PublicLayout = ({ background = null, children }) => (
  <div className="flex min-h-screen flex-col bg-[#232323] text-white">
    <div className="relative flex flex-1 flex-col">
      {background}
      <TopBar />
      <main className="relative flex-1">{children}</main>
    </div>
    <Footer />
  </div>
);

export default PublicLayout;
